import { ChevronRight } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { Loading } from "src/components/ui";
import {
	useAppDispatch,
	useAppSelector,
	setExporting,
	setAdsError,
	useLazyExportAdsQuery,
} from "src/store";

export const adTypes = [
	{ label: "Full-screen", slug: "full", color: "#7607BD", size: "340 x 800" },
	{ label: "Slider", slug: "carousel", color: "#55C4F1", size: "340 x 189" },
	{ label: "Pop-ups", slug: "banner", color: "#FFAD4A", size: "340 x 340" },
];

const AdsLanding = () => {
	const dispatch = useAppDispatch();
	const { exporting } = useAppSelector((state) => state.ads);
	const [exportAds] = useLazyExportAdsQuery();

	const handleExport = async () => {
		dispatch(setExporting(true));
		dispatch(setAdsError(null));

		try {
			const result = await exportAds("").unwrap();
			toast.success(result.message || "Success!");
			window.open(result.payload?.data?.fileUrl);
		} catch (error: any) {
			const errorMessage =
				error?.data?.error?.message || "An error occurred while exporting";
			dispatch(setAdsError(errorMessage));
			toast.error(errorMessage);
		} finally {
			dispatch(setExporting(false));
		}
	};
	return (
		<div>
			<div className='flex justify-between'>
				<h2 className='font-semibold text-2xl text-gray-700'>Ads Management</h2>
				<div className='flex gap-4'>
					<button
						onClick={handleExport}
						disabled={exporting}
						className='p-2 px-10 text-white bg-primary rounded-lg hover:bg-opacity-90 transition-colors flex items-center justify-center'
					>
						{exporting ? <Loading color='white' /> : "Export"}
					</button>
				</div>
			</div>
			<div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-10'>
				{adTypes.map((list, index) => {
					return (
						<Link
							to={`/ads-management?type=${list.slug}`}
							key={index}
							className={`shadow p-8 rounded-md flex items-center justify-between text-white`}
							style={{ backgroundColor: list.color }}
						>
							<h2 className='text-xl font-semibold'>{list.label}</h2>
							<ChevronRight />
						</Link>
					);
				})}
			</div>
		</div>
	);
};

export default AdsLanding;
